<template>
    <div class="container container-tabs">
        <div class="handle-box-search">
            <el-row class="head-search">
                <el-col :span="12">
                    <span class="title">诺诺发票编码:</span>
                    <el-input
                        v-model="search_data.order_invoice_code"
                        placeholder="请输入诺诺发票编码 "
                        @keyup.enter.native="searchorderInvoiceList"
                        class="handle-input mr10"
                    ></el-input>
                </el-col>
                <el-col :span="12">
                    <span class="title">手机号:</span>
                    <el-input
                        v-model="search_data.phone"
                        placeholder="请输入手机号"
                        maxlength="11"
                        @keyup.enter.native="searchorderInvoiceList"
                        class="handle-input mr10"
                    ></el-input>
                </el-col>
            </el-row>
            <el-row class="head-search">
                <el-col :span="24">
                    <span class="title">订单编号:</span>
                    <el-input
                        v-model="search_data.billno"
                        placeholder="订单号 "
                        @keyup.enter.native="searchorderInvoiceList"
                        class="handle-input mr10"
                    ></el-input>
                </el-col>
            </el-row>

            <el-button type="primary" icon="el-icon-search" @click="searchorderInvoiceList">搜索</el-button>
            <!-- <el-button @click="add_isShow = !add_isShow">添加</el-button> -->
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <div class="more-style">
                            <el-form-item label="订单号:">
                                <span v-for="(item, index) in props.row.order_code_array" style="display: block">{{ item }}</span>
                            </el-form-item>

                            <el-form-item label="是否发送邮箱:">
                                <span>{{ props.row.is_push_email.alias }}</span>
                            </el-form-item>

                            <el-form-item label="是否邮寄:">
                                <span>{{ props.row.is_mail.alias }}</span>
                            </el-form-item>
                        </div>

                        <div class="more-style">
                            <el-form-item label="所属城市:">
                                <span>{{ props.row.city.name }}</span>
                            </el-form-item>

                            <el-form-item label="地址:">
                                <span>{{ props.row.city.address ? props.row.city.address : '-' }}</span>
                            </el-form-item>

                            <el-form-item label="银行卡号:">
                                <span>{{ props.row.bank_number ? props.row.bank_number : '-' }}</span>
                            </el-form-item>
                        </div>
                    </el-form>
                </template>
            </el-table-column>

            <el-table-column prop="consumer_name" label="乘客名称" width="200"> </el-table-column>

            <el-table-column prop="consumer_phone" label="乘客电话" width="200"> </el-table-column>

            <el-table-column prop="invoice_status.alias" label="开票状态" width="200"> </el-table-column>

            <el-table-column prop="total_money" label="开票金额" min-width="150"> </el-table-column>

            <el-table-column prop="url" label="发票地址" min-width="200">
                <template slot-scope="scope">
                    <a :href="scope.row.url" target="_blank">{{ scope.row.url }}</a>
                </template>
            </el-table-column>

            <el-table-column prop="total_money" label="金额"> </el-table-column>

            <el-table-column prop="time.YmdHis" label="时间" width="200"> </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
          
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40,50]"
                :page-size="100"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
var _this;
export default {
    data() {
        return {
            activeName: 'all',

            time_stamp: '',

            // 下拉搜索管理状态
            value_status_code: '',
            value_status_array: '',

            order_code_array: '',

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                order_invoice_code: '',
                phone: '',
                billno: ''
            },

            result_data: {},
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.orderInvoiceList();
    },

    methods: {
        searchorderInvoiceList() {
            _this.search_data.page = 1;
            _this.orderInvoiceList();
        },

        // 搜索列表
        orderInvoiceList() {
            _this
                .$post('/order/orderInvoiceNouNouList', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;

                    _this.result_data = res;

                    _this.value_status_array = _this.tableData[0].invoice_status.select_array;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.orderInvoiceList();
        },
        handleSizeChange(val) {
           
            _this.search_data.limit = val;
            _this.orderInvoiceList();
        },
        handleCurrentChange(val) {
            _this.search_data.page = val;
            _this.orderInvoiceList();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}
</style>
